export const BREAKPOINT = '950px';
